import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@material-ui/core";
import axios from "axios";
import {AccountInfo, MemberInfo} from "../types/UserInfoTypes";
import config from '../config'
import PlusIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import { UsersPicker } from "./UsersPicker";

export function Users( props: {
  onChange: ((picker: AccountInfo | null) => void),
  groupName: string,
  groupMembers: MemberInfo[],
}): JSX.Element {

  const [open, setOpen] = useState<boolean>(false);
  const [user, setUser] = useState<AccountInfo|null>(null);

  async function updateMembership(groupName: string, userId: string, updateType: string){
          await axios.post(`${config.flowableUiApiBaseUrl}idm-app/rest/user/membership`, {groupName, userId, updateType}, {withCredentials: true}).then(() => {
              setOpen(false);
              props.onChange(null);
          }
  )}
          return <>
    <Dialog open={open} onClose={()=>setOpen(false)}>
      <DialogTitle>
        Add User To Group
        <IconButton style={{float:"right"}} onClick={()=>setOpen(false)}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <UsersPicker 
        onChange={p => p && setUser(p as AccountInfo)}
        groupMembers={props.groupMembers}
                />
        </DialogContent>
        <DialogActions>
                    <Button variant="contained" onClick={ () => {setOpen(false)}} style={{marginRight:"7px"}}>
                      CANCEL
                    </Button>
                    <Button color="primary" variant="contained"
                            onClick={() => {  
                              updateMembership(props.groupName, user ? user?.id : '','join')
                            }
                            }>
                            Add User
                    </Button>
          </DialogActions>
    </Dialog>
      <Button variant="outlined" size="small" style={{marginRight:"40px"}} startIcon={<PlusIcon />} 
      onClick={e => {
          setOpen(true)
          e.stopPropagation()
        }}>Add User To Group</Button>
      </>
}
